export default {
  // Page title
  title: 'Business Manager Configuration',

  // Search filter area
  search: {
    // Search condition labels
    employeeName: 'Employee Name',
    businessType: 'Business Type',
    position: 'Position',
    freightType: 'Freight Type',
    loadingPort: 'Loading Port',
    destinationPort: 'Destination Port',
    dischargePort: 'Discharge Port',
    route: 'Route',
    carrier: 'Carrier',
    client: 'Client',

    // Placeholders
    placeholder: {
      selectEmployee: 'Please select employee name',
      selectBusinessType: 'Please select business type',
      selectPosition: 'Please select position',
      selectFreightType: 'Please select freight type',
      selectLoadingPort: 'Please select loading port',
      selectDestinationPort: 'Please select destination port',
      selectDischargePort: 'Please select discharge port',
      selectRoute: 'Please select route',
      selectCarrier: 'Please select carrier',
      selectClient: 'Please select client'
    },

    // Buttons
    search: 'Search',
    reset: 'Reset',
    expand: 'Expand',
    collapse: 'Collapse'
  },

  // Action button area
  actions: {
    addManager: 'Add Manager',
    batchDelete: 'Batch Delete',
    totalRecords: 'Total {count} records'
  },

  // Table column headers
  table: {
    columns: {
      serialNumber: 'No.',
      employee: 'Employee',
      businessType: 'Business Type',
      position: 'Position',
      freightType: 'Freight Type',
      loadingPort: 'Loading Port',
      destinationPort: 'Destination Port',
      dischargePort: 'Discharge Port',
      route: 'Route',
      carrier: 'Carrier',
      client: 'Client',
      createdBy: 'Created By',
      createdTime: 'Created Time',
      modifiedBy: 'Modified By',
      modifiedTime: 'Modified Time',
      actions: 'Actions'
    },

    // Action buttons
    actions: {
      edit: 'Edit',
      delete: 'Delete'
    }
  },

  // Modal
  modal: {
    title: {
      add: 'Add Business Manager',
      edit: 'Edit Business Manager'
    },

    // Button text
    okText: 'Confirm',
    cancelText: 'Cancel',

    // Form sections
    sections: {
      basicInformation: 'Basic Information',
      businessConfiguration: 'Business Configuration',
      portAndRouteConfiguration: 'Port and Route Configuration',
      partnerConfiguration: 'Partner Configuration'
    },

    // Form fields
    form: {
      employee: 'Employee',
      businessType: 'Business Type',
      position: 'Position',
      freightType: 'Freight Type',
      loadingPort: 'Loading Port',
      destinationPort: 'Destination Port',
      dischargePort: 'Discharge Port',
      route: 'Route',
      carrier: 'Carrier',
      client: 'Client',

      // Placeholders
      placeholder: {
        selectEmployee: 'Please select employee',
        selectBusinessType: 'Please select business type',
        selectPosition: 'Please select position',
        selectFreightType: 'Please select freight type',
        selectLoadingPort: 'Please select loading port',
        selectDestinationPort: 'Please select destination port',
        selectDischargePort: 'Please select discharge port',
        selectRoute: 'Please select route',
        selectCarrier: 'Please select carrier',
        selectClient: 'Please select client'
      },

      // Validation messages
      validation: {
        selectEmployee: 'Please select employee',
        selectBusinessType: 'Please select business type',
        selectPosition: 'Please select position'
      }
    }
  },

  // Confirmation dialog
  confirm: {
    delete: {
      title: 'Confirm Delete',
      content: 'This cannot be undone. Are you sure of the delete? (Existing businesses not affected)',
      okText: 'Confirm',
      cancelText: 'Cancel'
    }
  },

  // Message prompts
  message: {
    success: {
      create: 'Created successfully',
      update: 'Updated successfully',
      delete: 'Deleted successfully',
      batchDelete: 'Successfully deleted {count} business managers'
    },
    error: {
      loadFailed: 'Data loading failed',
      createFailed: 'Creation failed',
      updateFailed: 'Update failed',
      deleteFailed: 'Deletion failed',
      batchDeleteFailed: 'Batch deletion failed',
      operationFailed: 'Operation failed'
    },
    warning: {
      managerIdNotExists: 'Business manager ID does not exist',
      noSelection: 'Please select business managers to delete'
    }
  }
}
